<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col text-center">
        <h1>Ordre du jour</h1>
        <h2>{{ building.name }}</h2>
      </div>
    </div>
    <div v-if="building.address" class="row mb-4">
      <div class="col text-center font-italic small">
        <div class="text-br-line">{{ building.address }}</div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col text-center">
        Assemblée générale
        <span
          v-if="meeting.allowed_modalities.physical || meeting.allowed_modalities.video"
          class="font-weight-bold"
        >
          {{
            $moment(toLocalTime(meeting.date)).locale("fr").format("[le] DD MMMM YYYY [à] HH[h]mm")
          }}
        </span>
        <span v-else class="font-weight-bold">
          {{ $moment(toLocalTime(meeting.date)).locale("fr").format("[le] DD MMMM YYYY") }}
        </span>
        <span v-if="meeting.allowed_modalities.physical">
          à l'adresse :
          <!-- eslint-disable-next-line prettier/prettier -->
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-if="meeting.address"
            class="text-br-line font-weight-bold mb-3"
            v-html="meeting.address"
          ></div>
          <div v-else class="text-danger">pas d'adresse définie</div>
        </span>
        <div v-if="meeting.access">
          Modalités d'accès :
          <div class="text-br-line font-weight-bold" v-html="meeting.access"></div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col text-center font-weight-bold">
        Cette Assemblée sera appelée a délibérer exclusivement sur l'ordre du jour suivant :
      </div>
    </div>
    <div v-for="(resolution, i) in mainResolutions" :key="`summary-${i}`" class="row">
      <div class="col">
        <span v-if="resolution.position" class="font-weight-bold">
          {{ resolution.position }}) {{ resolution.name }}
        </span>
        <span v-else class="text-danger">position non définie</span>
        <span
          v-if="
            resolution.majority &&
            resolution.children_resolutions.length == 0 &&
            resolution.majority_id != defaultSansVoteMajorityId
          "
        >
          - Majorité : {{ resolution.majority.name }}
          <span
            v-if="resolution.voting_category && resolution.majority_id != defaultSansVoteMajorityId"
          >
            - Clé de vote : {{ resolution.voting_category.name }}
          </span>
        </span>
        <span
          v-if="!resolution.majority && resolution.children_resolutions.length == 0"
          class="text-danger"
          >majorité non définie</span
        >
        <span
          v-if="
            resolution.majority &&
            resolution.children_resolutions.length == 0 &&
            resolution.majority_id == defaultSansVoteMajorityId
          "
        >
          - {{ resolution.majority.name }}
        </span>

        <div
          v-for="(child, j) in resolution.children_resolutions"
          :key="`child-${i}-${j}`"
          class="ml-3"
        >
          <span v-if="resolution.position && child.position" class="font-weight-bold">
            {{ resolution.position + "." + child.position }}) {{ child.name }}
          </span>
          <span v-else class="text-danger">position enfant non définie</span>
          <!-- Majorité and Clé for children resolution -->
          <span v-if="child.majority">
            <span v-if="resolution.majority_id != defaultSansVoteMajorityId">
              - Majorité : {{ child.majority.name }}
            </span>
            <span v-if="resolution.majority_id == defaultSansVoteMajorityId">
              - {{ child.majority.name }}
            </span>
            <span v-if="child.voting_category && child.majority_id != defaultSansVoteMajorityId">
              - Clé de vote :
              {{ child.voting_category.name }}
            </span>
          </span>
          <span v-else class="text-danger">majorité non définie</span>
        </div>
      </div>
    </div>
    <div class="new-page"></div>
    <div
      v-for="(resolution, i) in mainResolutions"
      :key="`resolution-${i}`"
      class="row mb-4 no-break"
    >
      <div class="col">
        <div v-if="resolution.position" class="font-italic font-weight-bold">
          Résolution n° {{ resolution.position }}
        </div>
        <div v-else class="text-danger">position non définie</div>
        <div class="font-weight-bold">{{ resolution.name }}</div>

        <span v-if="resolution.majority && resolution.children_resolutions.length == 0">
          <span v-if="resolution.majority_id != defaultSansVoteMajorityId">
            - Majorité : {{ resolution.majority.name }}
          </span>
          <span v-if="resolution.majority_id == defaultSansVoteMajorityId">
            - {{ resolution.majority.name }}
          </span>
          <span
            v-if="resolution.voting_category && resolution.majority_id != defaultSansVoteMajorityId"
          >
            - Clé de vote : {{ resolution.voting_category.name }}
          </span>
        </span>
        <span
          v-if="!resolution.majority && resolution.children_resolutions.length == 0"
          class="text-danger"
          >majorité non définie</span
        >

        <!-- eslint-disable-next-line prettier/prettier -->
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="resolution.description"
          class="text-br-line"
          v-html="resolution.description"
        ></div>

        <div
          v-for="(child, j) in resolution.children_resolutions"
          :key="`child-${i}-${j}`"
          class="ml-3 mt-4"
        >
          <span v-if="resolution.position && child.position" class="font-italic font-weight-bold">
            Sous résolution n° {{ resolution.position + "." + child.position }}
          </span>
          <span v-else class="text-danger">position enfant non définie</span>
          <div class="font-weight-bold">{{ child.name }}</div>
          <div v-if="child.majority" class="mb-2">
            <span v-if="child.majority_id != defaultSansVoteMajorityId">
              Majorité : {{ child.majority.name }}
            </span>
            <span v-if="child.majority_id == defaultSansVoteMajorityId">
              {{ child.majority.name }}
            </span>
            <span v-if="child.voting_category && child.majority_id != defaultSansVoteMajorityId">
              &nbsp; - Clé de vote : {{ child.voting_category.name }}
            </span>
          </div>
          <div v-else class="text-danger">majorité non définie</div>

          <div v-if="child.description" class="text-br-line" v-html="child.description"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultSansVoteMajorityId } from "@/constants/default.js";
export default {
  props: ["meeting", "building", "resolutions"],
  data() {
    return {
      defaultSansVoteMajorityId,
      mainResolutions: [],
    };
  },
  created() {
    this.extractMainResolutions();
  },
  methods: {
    extractMainResolutions() {
      let orderedResolutions = [];
      let sortedResolutions = this.$_.sortBy(this.resolutions, resolution => {
        return resolution.position;
      });
      sortedResolutions.forEach(resolution => {
        if (resolution.parent_resolution_id == null) {
          resolution.resolution_number = resolution.position;
          let childrenResolutions = this.$_.filter(sortedResolutions, item => {
            return item.parent_resolution_id == resolution.id;
          });
          if (childrenResolutions.length > 0) {
            childrenResolutions.forEach(chResolution => {
              chResolution.resolution_number =
                resolution.resolution_number.toString() + "." + chResolution.position.toString();
            });
            resolution.children_resolutions = childrenResolutions;
          }
          orderedResolutions.push(resolution);
        }
      });
      this.mainResolutions = orderedResolutions;
    },
  },
};
</script>
